import { Icon } from '@material-ui/core';
import React from 'react';

function StatusIcon(props) {
	switch (props.status) {
		case 'online':
			return <Icon className="block text-16 text-green bg-white rounded-full">check_circle</Icon>;
		case 'busy':
			return <Icon className="block text-16 text-white bg-yellow-700 rounded-full">access_time</Icon>;
		case 'absent':
			return <Icon className="block text-16 text-red bg-white rounded-full">remove_circle_outline</Icon>;
		case 'invisible-status':
			return <Icon className="block text-16 text-grey-700 bg-white rounded-full">not_interested</Icon>;
		case 'group-status':
			return <Icon className="block text-16 text-blue-700 bg-white rounded-full">group_work</Icon>;
		case 'calling':
			return <Icon className="block text-16 text-green bg-white rounded-full">ring_volume</Icon>;
		case '':
			return <Icon className="block text-16 text-white bg-white-700 rounded-full"></Icon>;
		default:
			return <Icon className="block text-16 text-white bg-white-700 rounded-full"></Icon>;
	}
}

export default StatusIcon;
